import { Table } from 'react-bootstrap';

import type { FiscalPeriod } from 'utils/fiscalPeriods';

interface Props {
  readonly periods: readonly FiscalPeriod[];
}

/** Per-period weeks and date bounds for the selected fiscal year. */
export const PeriodDetailTable = ({ periods }: Props) => (
  <Table size="sm" className="mb-4">
    <thead>
      <tr>
        <th>Period</th>
        <th>Quarter</th>
        <th>Weeks</th>
        <th>Starts</th>
        <th>Ends</th>
      </tr>
    </thead>
    <tbody>
      {periods.map((p) => (
        <tr key={p.period}>
          <td>{p.period}</td>
          <td>Q{p.quarter}</td>
          <td>{p.weeks}</td>
          <td className="font-monospace">{p.start}</td>
          <td className="font-monospace">{p.end}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);
